const categories = [
            'sanatoria', 'SPA', 'wellnes', 'SPA & Wellness', 'rehabilitacja', 'fizjoterapia', 'fizykoterapia', 'fitness', 'inne'
]
export default categories;